import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import Button from "../Buttons/Button";
import { useTranslationApp } from "../../lib/i18next";
import {
  CAMPAIGN_APPROVAL_COPY_LINK_BUTTON,
  CAMPAIGN_APPROVAL_COPY_LINK_COPIED,
  CONTENT_APPROVAL_REVIEW_LINK_LABEL,
} from "../../i18n/keysTranslations";
import { INPUT_COLOR_BORDER } from "../../utils/colors";

const ContentApprovalReviewLink = ({
  approvalUrl = "",
  onCopied = () => {},
}) => {
  const { t } = useTranslationApp();
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    setIsCopied(false);
  }, [approvalUrl]);

  if (!approvalUrl) {
    return null;
  }

  const onCopyLink = async () => {
    if (!navigator?.clipboard?.writeText) {
      return;
    }

    try {
      await navigator.clipboard.writeText(approvalUrl);
      setIsCopied(true);
      onCopied();
    } catch {
      // ignore clipboard errors
    }
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.75,
          mb: 0.75,
        }}
      >
        <LinkOutlinedIcon sx={{ fontSize: 14, color: "text.secondary" }} />
        <Typography
          variant="caption"
          sx={{
            textTransform: "uppercase",
            fontWeight: 700,
            letterSpacing: "0.5px",
            color: "text.secondary",
            fontSize: "0.65rem",
          }}
        >
          {t(CONTENT_APPROVAL_REVIEW_LINK_LABEL)}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          borderRadius: 1.5,
          bgcolor: "background.paper",
          pl: 1.25,
          pr: 0.5,
          py: 0.5,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            color: "text.secondary",
            fontFamily: "monospace",
          }}
        >
          {approvalUrl}
        </Typography>
        <Button
          type="button"
          color="secondary"
          onClick={onCopyLink}
          sx={{
            minWidth: "max-content",
            height: 32,
            px: 1.5,
            border: "none",
            boxShadow: "none",
          }}
        >
          {t(
            isCopied
              ? CAMPAIGN_APPROVAL_COPY_LINK_COPIED
              : CAMPAIGN_APPROVAL_COPY_LINK_BUTTON
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default ContentApprovalReviewLink;
